export default function parseContentStore() {
  const items = document.querySelectorAll("#sz-alert-source .sz-alert-item");
  const now = new Date();

  return Array.from(items)
    .map((el) => {
      const start = el.dataset.start ? new Date(el.dataset.start) : null;
      const end = el.dataset.end ? new Date(el.dataset.end) : null;

      const validStart = start instanceof Date && !isNaN(start);
      const validEnd = end instanceof Date && !isNaN(end);

      const isActive =
        (!validStart || now >= start) && (!validEnd || now <= end);
        
      const url =
        (el.dataset.url || "").trim() ||
        (el.dataset.sectionUrl || "").trim() ||
        null;

      const category = el.dataset.category
        ? el.dataset.category.split(",").map((c) => normaliseCategory(c.trim()))
        : [];

      return {
        title: el.querySelector(".sz-alert-title")?.textContent?.trim(),
        message: el.querySelector(".sz-alert-message")?.innerHTML,
        image: el.querySelector(".sz-alert-image")?.getAttribute("src"),
        url,
        category,
        isActive,
      };
    })
    .filter((item) => item.isActive);
}

function normaliseCategory(cat) {
  switch (cat.toLowerCase()) {
    case "calltoaction":
      return "cta";
    case "importantnow":
      return "important";
    default:
      return cat.toLowerCase();
  }
}
